<script>
    import svg from './feather';

    export let name = 'x';
    export let width = '100%';
    export let height = '100%';
    export let color = 'currentColor';
    export let fill = undefined;
    export let strokeWidth = 2;
    export let round = true;
    export let alt = name;
</script>

<svg
    class={`feather ${$$props.class || ''}`}
    {alt}
    {width}
    {height}
    viewbox='0 0 24 24'
    fill={fill ? fill : 'none'}
    stroke-linecap={round ? 'round' : ''}
    stroke-linejoin={round ? 'round' : ''}
    stroke-width={strokeWidth}
    stroke={color}>
    {@html svg[name]}
</svg>

<style>
    svg {
        margin: auto;
    }
</style>
